import { Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { CommonSelect } from '../../CommonComponents';

const AssignSite = ({ row, users, selectedUser }) => (
  <div>
    <div className="row">
      <div className="col-12">
        <Typography display="inline" color="secondary">
          Vendor:
          {' '}
          <b>{row.SupplierName}</b>
        </Typography>
        {' '}
      </div>
    </div>
    <br />
    <CommonSelect options={users} label="Users" handleChange={selectedUser} />
  </div>
);

const mapState = (state) => ({
  users: state.sites.vendorUsers,
});

export default connect(mapState, null)(AssignSite);
